const env = String( process?.env?.NODE_ENV || 'production').toLowerCase();

export const getSEONoFollow = () => env !== 'production';
export const getSEONoIndex = () => env !== 'production';